<h2 class="popup-heading" mat-dialog-title>{{ data.fireworkType ? 'Edit' : 'Add' }} Fireowrk Type</h2>
<form (ngSubmit)="submitForm($event)" [formGroup]="form">
  <mat-dialog-content class="mat-typography">
    <div class="errors">
      @for (error of errors | keyvalue; track error) {
        <span>{{ error.value }}</span>
      }
    </div>
    @for (language of languages; track language) {
      <mat-form-field appearance="fill">
        <mat-label>{{ language.name }}</mat-label>
        <input matInput [formControl]="form.controls['language_id_' + language.id]">
      </mat-form-field>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="cancel-popup" mat-button mat-dialog-close>Cancel</button>
    <button class="popup-save" mat-button type="submit" cdkFocusInitial [disabled]="processing">
      Save
      @if (processing) {
        <mat-icon>
          <mat-spinner color="accent" diameter="20"></mat-spinner>
        </mat-icon>
      }
    </button>
  </mat-dialog-actions>
</form>